// extracted by mini-css-extract-plugin
module.exports = {"emptyBox":"emptyBox--2v-lg","emptyData":"emptyData--1yyO5","emptyMessage":"emptyMessage--1jJMn"};